import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"

export const AdSpacing = styled("div")`
    @media (min-width: ${breakpoints.values.md}px) {
        min-height: 440px;
    }
`
